import { useTranslation } from 'react-i18next'

import { RadioGroup, Text } from '@reveni-io/reveni-ui'

import { getRefundHoldModeOptions } from './helpers'

const RefundHoldModeSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  const modeOptions = getRefundHoldModeOptions(t)

  return (
    <>
      <Text type="bodyMBold">{t('Mantener el reembolso en espera')}</Text>
      <RadioGroup name="refund-hold-mode" options={modeOptions} value={value} onChange={onChange} />
    </>
  )
}

export default RefundHoldModeSelector
